import palette from './palette';

const typography = {
    fontFamily: 'Open sans, sans-serif',
    fontSize: 14,
    h1: {
      color: palette.grey[600],
      fontSize: 40,
      fontWeight: 400,
    },
    h2: {
      color: palette.grey[600],
      fontSize: 32,
      fontWeight: 400,
    },
    h3: {
      color: palette.grey[600],
      fontSize: 24,
      fontWeight: 400,
    },
    h4: {
      color: palette.grey[600],
      fontSize: 20,
      fontWeight: 400,
    },
    body1: {
      color: palette.grey[600],
      fontSize: 16,
      fontWeight: 400,
    },
    body2: {
      color: palette.grey[600],
      fontSize: 14,
      fontWeight: 400,
    },
    caption: {
      color: palette.grey[600],
      fontSize: 12,
      fontWeight: 400,
    },
}

export default typography;